import { render, staticRenderFns } from "./WithdrawalInfo.vue?vue&type=template&id=057f0ec0&scoped=true&"
import script from "./WithdrawalInfo.vue?vue&type=script&lang=js&"
export * from "./WithdrawalInfo.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalInfo.vue?vue&type=style&index=0&id=057f0ec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f0ec0",
  null
  
)

export default component.exports